import React from 'react';
import { Box } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// CKEditor custom configuration
const editorConfig = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    '|',
    'outdent',
    'indent',
    '|',
    'blockQuote',
    'insertTable',
    'undo',
    'redo'
  ],
  placeholder: 'Enter your description here...',
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
    ]
  },
  // Additional configurations
  image: {
    toolbar: [
      'imageTextAlternative',
      'imageStyle:full',
      'imageStyle:side'
    ]
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells'
    ]
  }
};

// Custom styling for CKEditor
const editorStyles = {
  '.ck-editor__main': {
    minHeight: '200px',
    '& > .ck-editor__editable': {
      minHeight: '200px',
      maxHeight: '400px',
      fontSize: '14px',
      lineHeight: '1.5',
      padding: '16px'
    }
  },
  '.ck-toolbar': {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
  '.ck-content': {
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
  }
};

const RichTextEditor = ({ value, onChange, placeholder }) => {
  return (
    <Box
      sx={{
        '& .ck-editor__editable_inline': {
          minHeight: '200px',
          maxHeight: '400px'
        },
        '& .ck-rounded-corners': {
          borderRadius: '4px !important'
        },
        '& .ck.ck-editor__main > .ck-editor__editable': {
          fontSize: '14px',
          lineHeight: '1.5',
          padding: '0 16px 16px',
          borderTopLeftRadius: '0 !important',
          borderTopRightRadius: '0 !important'
        },
        '& .ck.ck-editor__main > .ck-editor__editable.ck-focused':
        {
          border: '1px solid #475969'

        },
        '& .ck.ck-toolbar': {
          borderTopLeftRadius: '4px !important',
          borderTopRightRadius: '4px !important',
          background: '#f8f9fa'
        },
        '& .ck.ck-content': {
          borderBottomLeftRadius: '4px !important',
          borderBottomRightRadius: '4px !important'
        }
      }}
    >
      <CKEditor
        editor={ClassicEditor}
        config={{
          ...editorConfig,
          placeholder: placeholder || editorConfig.placeholder
        }}
        data={value || ''}
        onReady={editor => {
          // You can customize the editor further when it's ready
          // editor.editing.view.change(writer => {
          //   writer.setStyle('height', '200px', editor.editing.view.document.getRoot());
          // });

          console.log('CKEditor is ready to use!', editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </Box>
  );
};

export default RichTextEditor;